import { render, staticRenderFns } from "./FeetPos.vue?vue&type=template&id=063c2cb8&"
import script from "./FeetPos.vue?vue&type=script&lang=js&"
export * from "./FeetPos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports